import { useCallback } from "react";

export const useValidateAttributePair = () => {
    const getValue = (param) => (typeof param.value === "object" ? param.value.value : param.value);

    return useCallback((attributeA, attributeB) => {
        const valueA = getValue(attributeA);
        const valueB = getValue(attributeB);

        return !valueA && !!valueB;
    }, []);
};
